import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
    return (
        <div className='min-h-[80vh] px-4 py-8 sm:px-6 sm:py-10 text-gray-800 dark:text-gray-200'>
            <div className=' p-4 sm:p-6 md:p-8 lg:p-10 max-w-7xl mx-auto'>
                <Link to="/" className='inline-block mb-4 sm:mb-6'>
                    <h1 className='text-indigo-500 font-bold text-2xl sm:text-3xl md:text-4xl logo-font'>Hazrat Ali</h1>
                </Link>
                
                <h1 className='text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6'>Privacy Policy of Hazrat Ali Portfolio</h1>
                
                <div className='space-y-4 sm:space-y-6 text-sm sm:text-base leading-relaxed'>
                    <p className='text-base sm:text-lg font-semibold'>Effective Date: January 1, 2025</p>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>1. Information Collection</h2>
                        <p>We collect information that you provide directly to us, including:</p>
                        <ul className='list-disc pl-5 sm:pl-6 mt-2 space-y-1'>
                            <li>Name and email address when subscribing to our newsletter</li>
                            <li>Profile information when creating an account</li>
                            <li>Comments and feedback you provide</li>
                            <li>Information shared through contact forms</li>
                        </ul>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>2. Technical Data Collection</h2>
                        <p>We automatically collect certain information when you visit our website:</p>
                        <ul className='list-disc pl-5 sm:pl-6 mt-2 space-y-1'>
                            <li>IP address and browser information</li>
                            <li>Device information and operating system</li>
                            <li>Pages visited and time spent on pages</li>
                            <li>Referral sources and exit pages</li>
                        </ul>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>3. Newsletter Subscription</h2>
                        <p>When you subscribe to our newsletter, we collect your email address to send you:</p>
                        <ul className='list-disc pl-5 sm:pl-6 mt-2 space-y-1'>
                            <li>Weekly technical articles and tutorials</li>
                            <li>Updates about new features and content</li>
                            <li>Occasional promotional content</li>
                        </ul>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>4. Data Usage & Processing</h2>
                        <p>We use your information to:</p>
                        <ul className='list-disc pl-5 sm:pl-6 mt-2 space-y-1'>
                            <li>Provide and improve our services</li>
                            <li>Personalize your experience</li>
                            <li>Communicate with you about updates</li>
                            <li>Analyze website performance</li>
                        </ul>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>5. GDPR Compliance</h2>
                        <p>For users in the European Union, we comply with GDPR requirements:</p>
                        <ul className='list-disc pl-5 sm:pl-6 mt-2 space-y-1'>
                            <li>Right to access your personal data</li>
                            <li>Right to rectification of incorrect data</li>
                            <li>Right to erasure of your data</li>
                            <li>Right to data portability</li>
                        </ul>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>6. CCPA Rights</h2>
                        <p>California residents have additional rights under CCPA:</p>
                        <ul className='list-disc pl-5 sm:pl-6 mt-2 space-y-1'>
                            <li>Right to know what personal information is collected</li>
                            <li>Right to delete personal information</li>
                            <li>Right to opt-out of data sales</li>
                            <li>Right to non-discrimination</li>
                        </ul>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>7. Data Security</h2>
                        <p>We implement appropriate security measures:</p>
                        <ul className='list-disc pl-5 sm:pl-6 mt-2 space-y-1'>
                            <li>SSL encryption for data transmission</li>
                            <li>Regular security audits</li>
                            <li>Limited access to personal data</li>
                            <li>Secure data storage practices</li>
                        </ul>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>8. Third-party Services</h2>
                        <p>We use trusted third-party services for:</p>
                        <ul className='list-disc pl-5 sm:pl-6 mt-2 space-y-1'>
                            <li>Analytics (Google Analytics)</li>
                            <li>Content delivery (Cloudflare)</li>
                        </ul>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>9. Contact for Privacy Concerns</h2>
                        <p>For privacy-related questions or concerns, please contact our Data Protection Officer at <a href="mailto:hazrataliein@gmail.com" className='text-indigo-500 hover:underline'>hazrataliein@gmail.com</a></p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;